/* istanbul ignore file */
import React from 'react';
import { ARTIFACT_ID } from 'domain/shared/artifact';
import { ArtifactUploaderInput, ArtifactUploaderInputProps } from 'domain/shared/artifact/input';

const CandidateResumeUploaderInput = (props: ArtifactUploaderInputProps) => {
  return <ArtifactUploaderInput {...props} artifactTypeId={ARTIFACT_ID.CANDIDATE_RESUME} />;
};

export default CandidateResumeUploaderInput;
